import { FC, memo } from 'react';
import * as Icons from '@ant-design/icons';
import { IScanItem } from '../interfaces';
import { RetryButton, ScanCode, ScanCodeText, ScanError, ScanErrorText, ScanInfo, ScanItem, ScanItemContent, ScanItemLeft, ScanNumber, ScanTime, ScanTrackCode, ScanTrackCodeText } from '../styled';

const getDisplayCode = (scan: IScanItem) => (scan.trendyol && scan.trendyol > 0 && scan.barcode ? scan.barcode : scan.trackCode?.toString() || '');

export const ScanRow: FC<{ item: IScanItem; onRetry: (scan: IScanItem) => void }> = memo(({ item, onRetry }) => (
  <ScanItem $status={item.status}>
    <ScanItemContent>
      <ScanItemLeft>
        <ScanNumber $status={item.status}>
          {item.status === 'success' && <Icons.CheckCircleOutlined style={{ fontSize: 16 }} />}
          {item.status === 'error' && <Icons.CloseCircleOutlined style={{ fontSize: 16 }} />}
          {item.status === 'pending' && <Icons.LoadingOutlined style={{ fontSize: 16 }} />}
        </ScanNumber>
        <ScanInfo>
          <ScanCode>
            <ScanCodeText>{getDisplayCode(item)}</ScanCodeText>
          </ScanCode>
          <ScanTime>{new Date(item.scannedAt).toLocaleTimeString('az-AZ')}</ScanTime>
          {item.status === 'error' && item.errorMessage && (
            <ScanError>
              <Icons.ExclamationCircleOutlined style={{ fontSize: 16, color: '#a8071a' }} />
              <ScanErrorText>{item.errorMessage}</ScanErrorText>
            </ScanError>
          )}
        </ScanInfo>
      </ScanItemLeft>
      {item.status === 'success' && (
        <ScanTrackCode>
          <ScanTrackCodeText>{item.trackCode?.toString() || ''}</ScanTrackCodeText>
        </ScanTrackCode>
      )}
      {item.status === 'error' && (
        <ScanTrackCode>
          <RetryButton onClick={() => onRetry(item)}>
            <Icons.ReloadOutlined /> Yenidən yoxla
          </RetryButton>
        </ScanTrackCode>
      )}
    </ScanItemContent>
  </ScanItem>
));

ScanRow.displayName = 'ScanRow';
